// extracted by mini-css-extract-plugin
module.exports = {"container":"phrases_container__2YIY2","phrase":"phrases_phrase__2XC7N","input":"phrases_input__3e8ln"};